import React from 'react';
import { IconHighlightM } from '../../icons';
import { somePeriodAgo } from '../../util/dates';
import config from '../../config';
import css from './IdentitySection.css';

const BadgeNewListing = ({ currentListing }) => {
    const createdAt = currentListing.attributes?.createdAt;
    const past = somePeriodAgo(config.newListingNumberOfDays, 'day');
    const isNewListing = createdAt && past < createdAt;

    return isNewListing ? (
        <div className={css.listingCardBadge}>
            <IconHighlightM />
            <span>Neu dabei</span>
        </div>
    ) : null;
};

export default BadgeNewListing;
